const draggable = {
  bind(el) {
    el.style.cursor = 'move'
    el.style.userSelect = 'none'

    el.addEventListener('mousedown', (e) => {
      if (e.target.closest('.v-btn') || e.target.closest('button')) return

      const dialog = el.closest('.v-dialog')
      if (!dialog) return

      const rect = dialog.getBoundingClientRect()
      const offsetX = e.clientX - rect.left
      const offsetY = e.clientY - rect.top

      dialog.style.position = 'absolute'
      dialog.style.margin = '0'
      dialog.style.left = rect.left + 'px'
      dialog.style.top = rect.top + 'px'

      const onMouseMove = (moveEvent) => {
        let newLeft = moveEvent.clientX - offsetX
        let newTop = moveEvent.clientY - offsetY

        newLeft = Math.max(
          0,
          Math.min(newLeft, window.innerWidth - dialog.offsetWidth)
        )
        newTop = Math.max(
          0,
          Math.min(newTop, window.innerHeight - dialog.offsetHeight)
        )

        dialog.style.left = newLeft + 'px'
        dialog.style.top = newTop + 'px'
      }

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
      e.preventDefault()
    })
  }
}

export default draggable
